import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from '../customer.service';
import { HelperService } from '../helper.service';
import { ToastService } from '../toasts.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  //declare variables
  customers: any[] = [];
  intCount: number = 0;

  //inject services
  constructor(private cs: CustomerService, private hs: HelperService, private router: Router, private tst: ToastService) { 
    
  }

  //initialize the component
  ngOnInit(): void {
    this.refresh();
  }

  //refresh the data
  refresh() {
    this.cs.get().subscribe(data => {
      this.customers = data;
      this.intCount = this.customers.length;
    })
  }

  //edit the customer
  edit(strID) {
    this.router.navigate(['/customer-form/' + strID]);
  }

  //delete the customer
  delete(strID) {
    if (confirm("Are you sure you want to permanently delete this customer?")) {
      //delete the lead
      this.cs.delete(strID);
      //alert on delete
      this.tst.show('Customer deleted successfully.', 'Deletion', 'fas fa-trash', { classname: 'bg-danger text-white text-center toaster', delay: 2000 });
      //refresh
      this.refresh();
    }
  }

  //create a new customer
  new() {
    this.router.navigate(['/customer-form']);
  }

}
